import { render, staticRenderFns } from "./InvitacionesPasoDatos.vue?vue&type=template&id=8e43ded4"
import script from "./InvitacionesPasoDatos.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesPasoDatos.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports